// extracted by mini-css-extract-plugin
module.exports = {"root":"CardExpend_root__2HQq1","label":"CardExpend_label__36_DA","content":"CardExpend_content__3V4U_"};